/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Country_PlaceholderInputs */

const en_orders_country_placeholder = /** @type {(inputs: Orders_Country_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US`)
};

const es_orders_country_placeholder = /** @type {(inputs: Orders_Country_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US`)
};

/**
* | output |
* | --- |
* | "US" |
*
* @param {Orders_Country_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_country_placeholder = /** @type {((inputs?: Orders_Country_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Country_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_country_placeholder(inputs)
	return es_orders_country_placeholder(inputs)
});